import { UserContext } from "wrapper/UserWrapper/context";
import { useTheme } from "emotion-theming";
import React, { useContext, useEffect, useState } from "react";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { getPlatform } from "../../../helpers";
import { getPaytmDetails, paytmRegister, paytmValidateOtp, paytmAddMoney, validateBankOffer } from "store/payment/services";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { validatePhoneNumber } from "helpers/utils/validatePhoneNumber";
import { PAYMENT_MODES } from "constants/paymentModes";
import { ValidateBankOfferParams } from "store/payment/@types";
import { OfferDataInterface } from "wrapper/PaymentWrapper/dependencies/utils/@types/savedMethods";
import { doCheckOffers } from "../../../logics/src/utils/checkOffers";
import { setBottomSheetBodyOverflow } from "helpers/utils/setBottomSheetBodyOverflow";
import { getOfferMessages, getPaymentOfferInfoConfig } from "../../../logics/src/utils/helpers";
import { getStringFromId } from "helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import OtpInput from "@nykaa/payment-sdk/src/OTPInput";

import PaytmWalletDesktop from "@nykaa/payment-sdk/src/PaytmWallet/desktop";
import PaytmWallet from "@nykaa/payment-sdk/src/PaytmWallet/mobile";
import PaymentOfferInfo from "@nykaa/payment-sdk/src/PaymentOfferInfo/mobile";
import PaymentOfferInfoDesktop from "@nykaa/payment-sdk/src/PaymentOfferInfo/desktop";
import { DEVICE_TYPE, BUTTON_TYPE } from "constants/index";
import { AppCallback, doAttachWebCallback, doCallAppCallback, WebCallback } from "helpers/utils/webView";
import { getMaskedPhoneNumber } from "./helpers";


interface IpaytmDetails {
  success: boolean;
  message: string;
  statusCode: string;
  phone: string;
  balance: number;
  isExpired: boolean;
}

interface IPaytmRegisterFailureApiResponse {
  data: {
    email: string;
    phoneNo: string;
    state: string;
  };
  message: string;
  statusCode: string;
  success: boolean;
  userTrackingId: string;
}

interface IPaytmRegisterSuccessApiResponse {
  email: string;
  phoneNo: string;
  state: string;
}

interface IpaytmSuccessValidateOtp {
  success: boolean;
  message: string;
  userTrackingId: string;
  statusCode: string;
  data: {
    customerId: number;
    email: string;
    phone: string;
    expiry: string;
    paytmCustomerId: string;
    balance: number;
    isExpired: boolean;
  };
}

interface IpaytmSuccessValidateOtp {
  customerId: number;
  email: string;
  phone: string;
  expiry: string;
  paytmCustomerId: string;
  balance: number;
  isExpired: boolean;
}

type IpaytmOTP = IPaytmRegisterSuccessApiResponse | IPaytmRegisterFailureApiResponse;
type IpaytmValidateOtp = IpaytmSuccessValidateOtp | IpaytmSuccessValidateOtp;


interface IpaytmAddMoney {
  success: boolean;
  message: string;
  userTrackingId: string;
  statusCode: string;
  data: {
    url: string;
    mid: string;
    txn_AMOUNT: string;
    channel_ID: string;
    industry_TYPE_ID: string;
    website: string;
    order_ID: string;
    cust_ID: string;
    callback_URL: string;
    checksumhash: string;
    sso_TOKEN: string;
    request_TYPE: string;
    merc_UNQ_REF: string;
  };
}

const PaytmWalletWrapper = ({
  cartRules,
  doPayment,
  isAccordianOpened,
  toggleNewPaymentAccordian,
  endIcon,
  isDisabled,
  strikedPaymentText,
  contentRefs,
  accordian,
}: any) => {
  const paymentContext: any = useContext(PaymentContext);
  const { applicationData } = useContext(ApplicationContext);
  const errorModalContext = useContext(ErrorModalContext);
  const { userData } = useContext(UserContext);

  const theme = useTheme() as Theme;
  const platform = getPlatform();

  const grandTotal = paymentContext?.orderAmount;
  const cartInfo = paymentContext?.cartInfo;
  const paymentInfo = paymentContext?.paymentInfo;
  const mobileNumber = paymentContext?.mobileNumber;
  const setLoading = paymentContext?.setLoading;

  const isPaytmConnected = paymentInfo?.isPaytmConnected;
  const shippingMobile = cartInfo?.contactNumber;
  const initialOrderAmount = cartInfo?.grandTotal;
  const deviceType = applicationData?.deviceType;
  const isApp = applicationData?.isApp;
  const isGuest = userData?.isGuest;
  const openErrorModal = errorModalContext?.openErrorModal;


  // first time autofill number based on priority
  const priorityNumber = mobileNumber ? mobileNumber : shippingMobile;
  const [payTmData, setPayTmData] = useState({
    unAuthorizedPaytmError: false,
    isPayTmUser: false,
    paytmBalance: 0,
  });
  const [phoneNumber, setPhoneNumber] = useState(priorityNumber);
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [otpError, setOtpError] = useState("");
  const [amountToAdd, setAmountToAdd] = useState(0);
  /* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
  const [payTmOtp, setPayTmOtp] = useState({} as IpaytmOTP);
  const [isOtpScreen, setIsOtpScreen] = useState(false);
  const [isCloseIconVisible, setIsCloseIconVisible] = useState(false);
  const [isResendOtpClicked, setIsResendOtpClicked] = useState(false);
  const [timer, setTimer] = useState(45);
  const [isPaymentOfferVisible, setIsPaymentOfferVisible] = useState(false);
  const [offerDetailConfig, setOfferDetailConfig] = useState({});
  /* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
  const [paytmOffer, setPaytmOffer] = useState({} as OfferDataInterface);
  const [otpAutoSubmit, setOtpAutoSubmit] = useState(false);

  useEffect(() => {
    /* eslint-disable @typescript-eslint/no-object-literal-type-assertion */
    setPaytmOffer({} as OfferDataInterface);
  }, [grandTotal]);

  useEffect(() => {
    setPhoneNumber(priorityNumber);
  }, [priorityNumber]);

  /*
  this useEffect gets the focus on the first input field once user opens the accordian
  */

  useEffect(() => {
    let paytmInputFieldAutoFocus = contentRefs?.current[PAYMENT_MODES.PAYTM]?.getElementsByClassName("input-element")[0];
    if (isPaytmConnected) {
      paytmInputFieldAutoFocus = contentRefs?.current[PAYMENT_MODES.PAYTM]?.getElementsByClassName("input-element")[1];
    }
    if (paytmInputFieldAutoFocus && isAccordianOpened) {
      setTimeout(() => {
        paytmInputFieldAutoFocus?.focus({ preventScroll: true });
      }, 20);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isAccordianOpened]);

    /*
    this useEffect gets the focus on the first input field once user opens the accordian in desktop
    */

    useEffect(() => {
      if (deviceType === DEVICE_TYPE.DESKTOP && accordian === PAYMENT_MODES.PAYTM) {
          let paytmInputFieldAutoFocus = contentRefs?.current[PAYMENT_MODES.PAYTM]?.getElementsByClassName(
              "input-element"
            )[0];
            if (isPaytmConnected) {
              paytmInputFieldAutoFocus = contentRefs?.current[PAYMENT_MODES.PAYTM]?.getElementsByClassName("input-element")[1];
            }
            if (paytmInputFieldAutoFocus && isAccordianOpened) {
              setTimeout(() => {
                paytmInputFieldAutoFocus?.focus({ preventScroll: true });
              }, 20);
            }
      }
      /* eslint-disable react-hooks/exhaustive-deps */
    }, [accordian]);

  useEffect(() => {
    if (isPaytmConnected) {
      setLoading(true);
      getPaytmDetails().then(
        (res: IpaytmDetails) => {
          if (res) {
            // sets the state whether user is paytm user or not
            // checks for phone and not expired to set it true
            if (res?.phone && !res?.isExpired) {
              setPayTmData({
                unAuthorizedPaytmError: false,
                isPayTmUser: true,
                paytmBalance: res.balance,
              });
            } else {
              setPayTmData({
                unAuthorizedPaytmError: true,
                isPayTmUser: false,
                paytmBalance: 0,
              });
            }
          }
        }
      );
      setLoading(false);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [getPaytmDetails, isGuest, isPaytmConnected]);

  useEffect(() => {
    const isPayTmUser = payTmData?.isPayTmUser;
    const payTmBalance = payTmData?.paytmBalance;
    let amountToBeAdd: string | number = 0;
    const orderAmountWithOffer = paytmOffer?.finalOrderAmount ? paytmOffer?.finalOrderAmount : grandTotal;
    // calculating amountToAdd only when order Amount greater then paytm balance
    if (orderAmountWithOffer <= payTmBalance) {
      setAmountToAdd(amountToBeAdd);
      return;
    }

    amountToBeAdd = (orderAmountWithOffer - payTmBalance).toFixed(2);

    if (isPayTmUser && amountToBeAdd) {
      setAmountToAdd(Math.ceil(amountToBeAdd));
    }
  }, [grandTotal, payTmData, paytmOffer?.finalOrderAmount]);

  const handleSendOTPClick = async () => {
    const params = {
      phone: phoneNumber,
    };
    return paytmRegister(params).then(
      (response: IpaytmOTP) => response
    );
  };

  const handleValidateOTPClick = async () => {
    const params = {
      phone: phoneNumber,
      otp: otpInput,
      state: (payTmOtp as IPaytmRegisterSuccessApiResponse)?.state,
      deviceType,
    };
    return paytmValidateOtp(params).then(
      (response: IpaytmValidateOtp) => response
    );
  };

  const handlePayTmAddMoney = async () => {
    const params = {
      amount: amountToAdd,
      deviceType,
    };
    return paytmAddMoney(params).then(
      (res: IpaytmAddMoney) => ({ res })
    );
  };

  /**
   * For stop the paytm otp auto detect broadcasting at the time of unmounting the component.
   */
  useEffect(() => () => {
      doCallAppCallback({
        name: AppCallback.DO_STOP_LISTEN_OTP_AUTO_DETECT,
        data: {},
      });
    }, []);

  const onOtpChange = (otpValue: string, autoSubmit?: boolean) => {
    otpValue = otpValue ? otpValue?.toString() : "";
    setOtpInput(otpValue);
    if (otpError) setOtpError("");
    /**
     * Incase of otp auto detect, we need to handle otp auto submit functionality.
     */
     if (autoSubmit) {
      setOtpAutoSubmit(autoSubmit);
    }
  };

  const handleLinkPaytmSubmit = () => {
    // validation for phone number submit

    const phoneVernacularError = {
      required: requiredErrorMessage,
      invalid: phoneNumberErrorMessage,
    };
    const phoneNumberStatus = validatePhoneNumber(
      phoneNumber,
      phoneVernacularError
    );
    if (!phoneNumberStatus.hasError) {
      setLoading(true);
      handleSendOTPClick()
        .then(
          (response: IpaytmOTP) => {
            const success = (response as IPaytmRegisterFailureApiResponse)?.success;
            const message = (response as IPaytmRegisterFailureApiResponse)?.message;
            if (response && message && !success) {
              setLoading(false);
              openErrorModal(PAYMENT_ERROR_MESSAGE.FAILED, message);
              return;
            }
            setPayTmOtp(response);
            setIsOtpScreen(true);
            setIsResendOtpClicked(true);
            setLoading(false);
            setOtpInput("");
            /**
             * For start the broadcasting of paytm otp auto detect in webview.
             */
             if (isApp) {
              doAttachWebCallback({
                callbackName: WebCallback.DO_GET_OTP_AUTO_DETECT,
                callbackDeclaration: (otpValue: string) => {
                  onOtpChange(otpValue, true);
                },
              });
              doCallAppCallback({
                name: AppCallback.DO_START_LISTEN_OTP_AUTO_DETECT,
                data: {
                  callback: WebCallback.DO_GET_OTP_AUTO_DETECT,
                },
              });
            }
          }
        )
        .catch(() => {
          // logger.error(error, 'send Otp failed MobileWalletWrapper');
          setLoading(false);
        });
    } else {
      setPhoneNumberError(phoneNumberStatus.error);
    }
  };

  const toggleOtpScreen = () => {
    /**
     * For stop the paytm otp auto detect broadcasting incase of close the bottom sheet.
     */
     if (isApp && isOtpScreen) {
      doCallAppCallback({
        name: AppCallback.DO_STOP_LISTEN_OTP_AUTO_DETECT,
        data: {},
      });
    }
    setOtpInput("");
    setIsOtpScreen(!isOtpScreen);
  };

  const handleOtpVerifySubmit = () => {
    if (otpInput.length !== 6 || otpError) {
      return;
    }
    if (isOtpScreen) {
      /**
       * For stop the paytm otp auto detect broadcasting.
       */
      if (isApp) {
        doCallAppCallback({
          name: AppCallback.DO_STOP_LISTEN_OTP_AUTO_DETECT,
          data: {},
        });
      }

      setLoading(true);
      handleValidateOTPClick()
        .then(
          (response: IpaytmValidateOtp) => {
            const success = response?.success;
            const message = response?.message;
            if (response && message && !success) {
              setOtpError(message);
              setLoading(false);
              return;
            }
            let paytmOffers = cartRules?.paymentRules?.filter(
              (rule: PaymentOfferRule) =>
                rule.paymentMethod === "paytm_auto_debit"
            );
            // sort based on priority
            if (paytmOffers?.length > 1) {
              paytmOffers = paytmOffers.sort(
                (a: PaymentOfferRule, b: PaymentOfferRule) =>
                  b?.priority - a?.priority
              );
            }
            if (paytmOffers?.length) {
              const offerData = paytmOffers[0];
              if (offerData) {
                if (offerData?.ruleKey) {
                  const validateBankOfferParams: ValidateBankOfferParams = {
                    deviceType,
                    mode: PAYMENT_MODES.MOBILE_WALLETS.toUpperCase(),
                    offerKeyList: [offerData?.ruleKey],
                    paymentInstrumentDTO: {
                      phoneNo: phoneNumber,
                    },
                  };

                  /* eslint-disable no-shadow */
                  validateBankOffer(validateBankOfferParams).then(
                    (response: {
                      success: boolean;
                      message: string;
                      statusCode: string;
                      eligibleOffers: string[];
                    }) => {
                      if (response) {
                        const offer: OfferDataInterface = doCheckOffers(
                          false,
                          "paytm_auto_debit",
                          cartRules,
                          paymentInfo,
                          response?.eligibleOffers
                        );
                        if (offer?.hasOffers) {
                          setPaytmOffer(offer);
                          // setOfferValidate(true);
                        }
                      }
                    }
                  );
                }
              }
            }
            setPayTmData({
              unAuthorizedPaytmError: false,
              isPayTmUser: true,
              paytmBalance: response.balance,
            });
            toggleOtpScreen();
            setLoading(false);
            setOtpAutoSubmit(false);
          }
        )
        .catch(() => {
          // logger.error(error, 'validate Otp failed MobileWalletWrapper');
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (otpAutoSubmit) {
      handleOtpVerifySubmit();
    }
  }, [otpAutoSubmit]);

  const onPhoneNumberChange = (value: string) => {
    value = value.replace(/[^0-9]/g, "");
    if (value.length > 10) return;
    if (phoneNumberError) setPhoneNumberError("");
    setPhoneNumber(value);
    if (!value) setIsCloseIconVisible(false);
    if (!isCloseIconVisible) setIsCloseIconVisible(true);
  };

  const resendOtpClick = () => {
    setIsResendOtpClicked(true);
    handleSendOTPClick().then((res: IPaytmRegisterSuccessApiResponse | IPaytmRegisterFailureApiResponse) => res);
  };

  const clearPhoneNumberInput = () => {
    setPhoneNumber("");
    setPhoneNumberError("");
    setIsCloseIconVisible(false);
  };

  /* eslint-disable no-shadow */
  const timerCallback = (timer: number) => {
    setTimer(timer);
  };

  const toggleResendOtpClick = () => {
    setIsResendOtpClicked(!isResendOtpClicked);
  };

  const handleInputFocus = () => {
    if (phoneNumber) {
      setIsCloseIconVisible(true);
    }
  };

  const handleInputBlur = () => {
    setIsCloseIconVisible(false);
  };


  const togglePaymentOfferDetails = (e: Event) => {
    e?.preventDefault();
    e?.stopPropagation();
    setIsPaymentOfferVisible(!isPaymentOfferVisible);
  };

  useEffect(() => {
    let paytmOffers = cartRules?.paymentRules?.filter(
      (rule: PaymentOfferRule) => rule.paymentMethod === "paytm_auto_debit"
    );
    // sort based on priority
    if (paytmOffers?.length > 1) {
      paytmOffers = paytmOffers.sort(
        (a: PaymentOfferRule, b: PaymentOfferRule) => b?.priority - a?.priority
      );
    }
    if (paytmOffers?.length) {
      const offerData = paytmOffers[0];
      if (offerData) {
        const offer: OfferDataInterface = doCheckOffers(
          false,
          "paytm_auto_debit",
          cartRules,
          paymentInfo,
          [offerData?.ruleKey as string]
        );
        if (offer?.hasOffers) {
          setPaytmOffer(offer);
        }
      }
    }
  }, [cartRules]);

  useEffect(() => {
    if (Object.keys(paytmOffer)?.length) {
      const offerDetails = getPaymentOfferInfoConfig({
        offerData: paytmOffer,
        theme,
        action: togglePaymentOfferDetails,
        deviceType,
        isVisible: isPaymentOfferVisible,
      });
      setOfferDetailConfig(offerDetails);
    }
  }, [paytmOffer, isPaymentOfferVisible]);

  const alertMessage = "";
  const offerMessage = "";
  // const loading = get(callbacks, 'loading');
  const isPayTmUser = payTmData?.isPayTmUser;
  const paytmBalance = payTmData?.paytmBalance;

  const requiredErrorMessage = getStringFromId(
    VERNACULAR_STRING_IDS.THIS_FIELD_IS_REQUIRED,
    VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED
  );
  const phoneNumberErrorMessage = getStringFromId(
    VERNACULAR_STRING_IDS.PHONE_NUMBER,
    VERNACULAR_DEFAULT_MESSAGES.PHONE_NUMBER_NOT_VALID
  );


  let title = getStringFromId(
    VERNACULAR_STRING_IDS.PAYTM_WALLET_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.PAYTM_WALLET_TITLE
  );
  if (deviceType === DEVICE_TYPE.DESKTOP) {
    title = getStringFromId(
      VERNACULAR_STRING_IDS.PAYTM_WALLET_TITLE_DESKTOP,
      VERNACULAR_DEFAULT_MESSAGES.PAYTM_WALLET_TITLE_DESKTOP
    );
  }
  const subTitle = getStringFromId(
    VERNACULAR_STRING_IDS.PAYTM_WALLET_SUBTITLE,
    VERNACULAR_DEFAULT_MESSAGES.PAYTM_WALLET_SUBTITLE
  );
  const resendOtp = getStringFromId(
    VERNACULAR_STRING_IDS.RESEND_OTP,
    VERNACULAR_DEFAULT_MESSAGES.RESEND_OTP
  );
  let dynamicResendOtp = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_RESEND_OTP,
    `Resend OTP in 00:${timer < 10 ? `0${timer}` : timer}`,
    { timer: `00:${timer < 10 ? `0${timer}` : timer}` }
  );
  const phoneNumberLabel = getStringFromId(
    VERNACULAR_STRING_IDS.PHONE_NUMBER,
    VERNACULAR_DEFAULT_MESSAGES.PHONE_NUMBER
  );
  const amountLabelText = getStringFromId(
    VERNACULAR_STRING_IDS.AMOUNT,
    VERNACULAR_DEFAULT_MESSAGES.AMOUNT
  );
  const linkPaytmWalletText = getStringFromId(
    VERNACULAR_STRING_IDS.LINK_PAYTM_WALLET,
    VERNACULAR_DEFAULT_MESSAGES.LINK_PAYTM_WALLET
  );
  const linkText = getStringFromId(
    VERNACULAR_STRING_IDS.LINK,
    VERNACULAR_DEFAULT_MESSAGES.LINK
  );
  const confirmOtpText = getStringFromId(
    VERNACULAR_STRING_IDS.CONFIRM_OTP,
    VERNACULAR_DEFAULT_MESSAGES.CONFIRM_OTP
  );
  const addMoneyText = getStringFromId(
    VERNACULAR_STRING_IDS.ADD_MONEY,
    VERNACULAR_DEFAULT_MESSAGES.ADD_MONEY
  );

  const verifyOtpProps = {
    autoFocus: true,
    isNumberInput: true,
    length: 6,
    className: "otpContainer",
    inputClassName: "otpInput",
    onChangeOTP: onOtpChange,
    placeholder: "",
    otpInput,
  };

  const amountToPayText = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_PAY,
    `Pay ₹${grandTotal}`,
    { count: grandTotal }
  );
  const maskedPhoneNumber = getMaskedPhoneNumber(phoneNumber);
  const paytmVerifyNumberText = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_PAYTM_WALLET_VERIFY_NUMBER,
    `To use your paytm wallet, kindly verify your mobile number ${maskedPhoneNumber}`,
    { number: maskedPhoneNumber }
  );
  const paytmLowBalanceText = getStringFromId(
    VERNACULAR_STRING_IDS.DYANMIC_PAYTM_LOW_BALANCE,
    `Low Balance you need ₹${amountToAdd} more in your account`,
    { amount: amountToAdd }
  );
  let payNowText = amountToPayText;
  let revisedPayNowText = "";
  if (isPayTmUser) {
    if (amountToAdd > 0) {
      payNowText = addMoneyText;
    } else if (paytmOffer?.hasOffers) {
      revisedPayNowText = getStringFromId(
        VERNACULAR_STRING_IDS.DYNAMIC_PAY_WITH_STRIKED_AMOUNT,
        `Pay ₹${paytmOffer?.finalOrderAmount} &nbsp; <del> ₹${initialOrderAmount}</del>`,
        {
          oldAmount: initialOrderAmount,
          newAmount: paytmOffer?.finalOrderAmount || "",
        }
      );
    } else if (strikedPaymentText) {
      revisedPayNowText = strikedPaymentText;
    } else {
      payNowText = amountToPayText;
    }
  } else {
    if (isGuest) {
      payNowText = amountToPayText;
    } else {
      payNowText = linkText;
    }
  }

  const alertLowBalanceText = amountToAdd > 0 ? paytmLowBalanceText : "";
  const config = {
    isAccordianOpened,
    toggleAccordian: () => toggleNewPaymentAccordian(PAYMENT_MODES.PAYTM, isDisabled),
    title,
    leadingIcon: getIcons(platform, ICONS_NAMES.PAYTM),
    endIcon,
    VerifyOtpInput: OtpInput,
    isPayTmUser,
    isGuest,
    doPayment: () => {
      // Required for adding Money to wallet and giftcard purchase
      doPayment(PAYMENT_MODES.PAYTM, {
        amountToAdd,
        isPayTmUser,
        handlePayTmAddMoney,
        offerData: paytmOffer,
        grandTotal,
        paymentInfo: phoneNumber,
      });
    },
    onPhoneNumberChange,
    phoneNumber,
    otpError,
    otpInput,
    onResendOtpClick: resendOtpClick,
    otpTimer: timer,
    resendOtpText: isResendOtpClicked ? dynamicResendOtp : resendOtp,
    isResendOtpDisabled: isResendOtpClicked,
    isBottomSheetOpened: isOtpScreen,
    bottomSheetTitleText: linkPaytmWalletText,
    bottomSheetSubTitleText: paytmVerifyNumberText,
    bottomSheetButtonText: confirmOtpText,
    toggleBottomSheet: toggleOtpScreen,
    subTitle,
    alert: {
      leadingIcon: getIcons(platform, ICONS_NAMES.ALERT),
      warn: true,
      text: alertMessage || alertLowBalanceText,
    },
    offerText: offerMessage,
    balanceText: isPayTmUser ? `₹${paytmBalance}` : "",
    inputIcon: getIcons(platform, ICONS_NAMES.CLEAR),
    isInputIconVisible: isCloseIconVisible,
    onInputIconClick: clearPhoneNumberInput,
    payNowText,
    revisedPayNowText,
    phoneNumberLabelText: phoneNumberLabel,
    phoneNumberErrorText: phoneNumberError,
    otpLength: 6,
    verifyOtpProps,
    // accordianIcon: ,
    bottomSheetActionButtonClick: handleOtpVerifySubmit,
    handlePhoneVerifySubmit: handleLinkPaytmSubmit,
    amountToAdd,
    amountLabelText,
    onInputFocus: handleInputFocus,
    onInputBlur: handleInputBlur,
    theme,
    timerCallback, // timer for counter
    toggleResendOtpClick, // callback after timer stops
    offerMessages: paytmOffer && getOfferMessages(paytmOffer, theme, togglePaymentOfferDetails),
    offerDetailConfig,
    isDisabled,
    buttonType: BUTTON_TYPE.MEDIUM,
    deviceType,
  };

  /**
   * @todo add VerifyOtpInput type
   */
  if (deviceType === DEVICE_TYPE.DESKTOP) {
    return <>
      <PaytmWalletDesktop {...config} />
      {Boolean(Object.keys(config?.offerDetailConfig)?.length) && <PaymentOfferInfoDesktop {...offerDetailConfig} />}
    </>;
  }

  return (
    <>
      <PaytmWallet {...config} theme={theme} />
      {Boolean(Object.keys(config?.offerDetailConfig)?.length) && <PaymentOfferInfo {...offerDetailConfig} />}
    </>
  );
};

export default PaytmWalletWrapper;
